module.exports = __webpack_public_path__ + "img/7100.daf17d0e.svg";